export { AtnDsNumberConfig as Config } from './number-config.namespace'
export { AtnDsNumberType as Type } from './number-type.namespace'
